"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var roosterjs_editor_api_1 = require("roosterjs-editor-api");
var ENTITY_TYPE = 'WATERMARK_WRAPPER';
/**
 * A watermark plugin to manage watermark string for roosterjs
 */
var Watermark = /** @class */ (function () {
    /**
     * Create an instance of Watermark plugin
     * @param watermark The watermark string
     */
    function Watermark(watermark, format) {
        var _this = this;
        this.watermark = watermark;
        this.format = format;
        this.showHideWatermark = function () {
            var hasFocus = _this.editor.hasFocus();
            var watermarks = _this.editor.queryElements(roosterjs_editor_dom_1.getEntitySelector(ENTITY_TYPE));
            var isShowing = watermarks.length > 0;
            if (hasFocus && isShowing) {
                watermarks.forEach(_this.removeWatermark);
                _this.editor.focus();
            }
            else if (!hasFocus && !isShowing && _this.editor.isEmpty()) {
                roosterjs_editor_api_1.insertEntity(_this.editor, ENTITY_TYPE, _this.editor.getDocument().createTextNode(_this.watermark), false /*isBlock*/, false /*isReadonly*/, 0 /* Begin */);
            }
        };
        this.removeWatermark = function (wrapper) {
            var parentNode = wrapper.parentNode;
            parentNode === null || parentNode === void 0 ? void 0 : parentNode.removeChild(wrapper);
            // After remove watermark node, if it leaves an empty DIV, append a BR node into it to make it a regular empty line
            if (_this.editor.contains(parentNode) &&
                roosterjs_editor_dom_1.getTagOfNode(parentNode) == 'DIV' &&
                !parentNode.firstChild) {
                parentNode.appendChild(_this.editor.getDocument().createElement('BR'));
            }
        };
        this.format = this.format || {
            fontSize: '14px',
            textColors: {
                lightModeColor: '#AAAAAA',
                darkModeColor: '#6B6B6B',
            },
        };
    }
    /**
     * Get a friendly name of  this plugin
     */
    Watermark.prototype.getName = function () {
        return 'Watermark';
    };
    /**
     * Initialize this plugin. This should only be called from Editor
     * @param editor Editor instance
     */
    Watermark.prototype.initialize = function (editor) {
        this.editor = editor;
        this.disposer = this.editor.addDomEventHandler({
            focus: this.showHideWatermark,
            blur: this.showHideWatermark,
        });
    };
    /**
     * Dispose this plugin
     */
    Watermark.prototype.dispose = function () {
        this.disposer();
        this.disposer = null;
        this.editor = null;
    };
    /**
     * Handle events triggered from editor
     * @param event PluginEvent object
     */
    Watermark.prototype.onPluginEvent = function (event) {
        var _a;
        if (event.eventType == 11 /* EditorReady */ ||
            (event.eventType == 7 /* ContentChanged */ &&
                ((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) != ENTITY_TYPE)) {
            this.showHideWatermark();
        }
        else if (event.eventType == 15 /* EntityOperation */ &&
            event.entity.type == ENTITY_TYPE) {
            var operation = event.operation, wrapper = event.entity.wrapper;
            if (operation == 8 /* ReplaceTemporaryContent */) {
                this.removeWatermark(wrapper);
            }
            else if (event.operation == 0 /* NewEntity */) {
                roosterjs_editor_dom_1.applyFormat(wrapper, this.format, this.editor.isDarkMode());
                wrapper.spellcheck = false;
            }
        }
    };
    return Watermark;
}());
exports.default = Watermark;
//# sourceMappingURL=Watermark.js.map